import { render, staticRenderFns } from "./resultsEmpty.vue?vue&type=template&id=6b176aa0&"
import script from "./resultsEmpty.vue?vue&type=script&lang=js&"
export * from "./resultsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports